module.exports = __webpack_public_path__ + "img/alipay.5cd26270.png";